// src/services/sales.ts
//
// Sales-domain service. Backs the sales dashboard, user sales-journey timeline
// (with callback-completion + meeting-schedule updates), the lifecycle client
// list, and the assign-nutritionist flow (primary/backup) plus the lookup of
// already-assigned nutritionists for a user.

import { apiFetch } from "../Component/api/apiFetch";
import { API_URLS } from "../Component/api/url";
import { handleJson } from "./http";

export const getSalesDashboard = (): Promise<any> =>
  handleJson(apiFetch(API_URLS.SALES_DASHBOARD, { method: "GET" }));

export const getUserSalesJourney = (userId: string | number): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_USER_SALES_JOURNEY(userId), { method: "GET" })
  );

export const completeCallbackRequest = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.UPDATE_SALES_JOURNEY_COMPLETED_CALL_REQUEST, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const updateJourneyStep = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.UPDATE_SALES_JOURNEY_SCHEDULE_MEETING, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const getSalesClientDetailsList = (
  lifecycle: "client" | "churned" | "all" = "all",
  assignment: "assigned" | "unassigned" | "all" = "all",
  page: number = 1,
  pageSize: number = 10,
  searchUser: string = ""
): Promise<any> =>
  handleJson(
    apiFetch(
      API_URLS.GET_SALES_CLIENT_DETAILS_LIST(
        lifecycle,
        assignment,
        page,
        pageSize,
        searchUser
      ),
      { method: "GET" }
    )
  );

export const getAvailableNutritionistsList = (): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_AVAILABLE_NUTRITIONISTS_LIST, { method: "GET" })
  );

export const assignPrimaryNutritionist = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.ASSIGN_PRIMARY_NUTRITIONIST, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const assignBackupNutritionist = (
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.ASSIGN_BACKUP_NUTRITIONIST, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const getAssignedNutritionists = (
  userId: string | number
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_ASSIGNED_NUTRITIONISTS(userId), { method: "GET" })
  );
